    /////////////////////
 //█▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
//█░░╦─╦╔╗╦─╔╗╔╗╔╦╗╔╗░░█
//█░░║║║╠─║─║─║║║║║╠─░░█
//█░░╚╩╝╚╝╚╝╚╝╚╝╩─╩╚╝░░█
//█▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█
//
//░██████╗████████╗██████╗░███████╗░█████╗░███╗░░░███╗
//██╔════╝╚══██╔══╝██╔══██╗██╔════╝██╔══██╗████╗░████║
//╚█████╗░░░░██║░░░██████╔╝█████╗░░███████║██╔████╔██║  
//░╚═══██╗░░░██║░░░██╔══██╗██╔══╝░░██╔══██║██║╚██╔╝██║
//██████╔╝░░░██║░░░██║░░██║███████╗██║░░██║██║░╚═╝░██║
//╚═════╝░░░░╚═╝░░░╚═╝░░╚═╝╚══════╝╚═╝░░╚═╝╚═╝░░░░░╚═╝
//                      
//        █▄▄ █▄█   █▀▀ █▄█ █▄▄ █▀▀ █▀█ █▀▀ █▀█ ▄▀█ █▀█
//        █▄█ ░█░   █▄▄ ░█░ █▄█ ██▄ █▀▄ █▄▄ █▀▄ █▀█ █▀▀
////////////////////

import './style.css'
import * as THREE from 'three'
import { SphereGeometry } from 'three';
const { noise, noiseSeed } = require('@chriscourses/perlin-noise')
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js'
import { Lensflare, LensflareElement } from 'three/examples/jsm/objects/Lensflare.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import { AfterimagePass } from 'three/examples/jsm/postprocessing/AfterimagePass.js';
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';

let width = window.innerWidth;
let height = window.innerHeight;

let pIndex = Math.floor(random(0,15))


let cDec;

let p = [];
let nsSpeed = random(0.002,0.004)
let maxP
if(nsSpeed>0.003){
 maxP = Math.floor(random(1500,2000));
}
if(nsSpeed<0.0025){
    maxP = 1500
}
else{
maxP = 2000;
}


let shapeDec = Math.floor(random(0,2));

let inc = 0 //increment

noiseSeed(fxrand()*99999)

colorPallete()
features()

//SCENE
const scene = new THREE.Scene()
colorPallete()
scene.background = new THREE.Color(0x000000)


//CAMERA
const camera = new THREE.PerspectiveCamera(25, width/height, 0.01, 1000)
camera.position.x = 4.08
camera.position.z = 4.2;
camera.position.y = 4.06
camera.lookAt(0,0,0)

scene.add(camera)

//FOG
scene.fog = new THREE.FogExp2(0x000000,0.106)

//LIGHTS
const hemiLight = new THREE.HemisphereLight(cDec,0x000000,1.5)
scene.add(hemiLight)
colorPallete()
const pLight1 = new THREE.PointLight(cDec,20,5,2.5)
pLight1.position.set(0,1.5,0)
scene.add(pLight1)
colorPallete()
const pLight2= new THREE.PointLight(cDec,20,5,2.5)
pLight2.position.set(0,-1.5,0)
scene.add(pLight2)
const textureLoader = new THREE.TextureLoader();

const textureFlare0 = textureLoader.load( "1.png" );
const textureFlare1 = textureLoader.load( "2.png" );
const textureFlare2 = textureLoader.load( "3.png" );

const lensflare = new Lensflare();

//lensflare.addElement( new LensflareElement( textureFlare0, 200, 0 ) );
//lensflare.addElement( new LensflareElement( textureFlare1, 200, 0 ) );
if(random(0,1)>0.5){
lensflare.addElement( new LensflareElement( textureFlare2, random(200,350), 0.6 ) );
}
else{
    lensflare.addElement(new LensflareElement(textureFlare0,random(200,350),0.6))
}

//pLight1.add( lensflare );
pLight2.add(lensflare)

//RENDERER
const renderer = new THREE.WebGLRenderer()
renderer.setSize(width,height)
document.body.appendChild(renderer.domElement);

//CONTROLS
const controls = new OrbitControls(camera,renderer.domElement)
controls.enableZoom = false; 
controls.minPolarAngle = -Math.PI; // radians
controls.maxPolarAngle = Math.PI/2; // radians
controls.minAzimuthAngle = - Math.PI/8; // radians
controls.maxAzimuthAngle = Math.PI/2 // radians

//PARTICLES
class Particles{
    constructor(){

this.vlZ = random(-1,1)
this.radius = random(0,0.02)
if(shapeDec==0&&nsSpeed<0.003){
    this.spGeo = new THREE.BoxGeometry(0.02,0.1,0.02) 
}
else{
    this.spGeo = new THREE.SphereGeometry(this.radius,8,8)
}

colorPallete()
this.color = new THREE.Color(cDec)
this.material = new THREE.MeshLambertMaterial({color: this.color})
this.sphere = new THREE.Mesh(this.spGeo,this.material);

this.nsOff = 0;
    }

    display(){
        scene.add(this.sphere)
    }

    fall(){
        this.sphere.position.x=mapRange(noise(this.nsOff),0,1,-4,4)/2+this.vlZ
        this.sphere.position.z=mapRange(noise(this.nsOff+100),0,1,-4,4)/2+this.vlZ
        this.sphere.position.y = mapRange(noise(this.nsOff+50),0,1,-4,4)/2+this.vlZ
        this.nsOff+=nsSpeed
        
    }
    die(){
        if(p.length>maxP){
            scene.remove(this.sphere);
        }
    }
}

//POINTS
let x,y,z
let vertCount = 200
const ptsGeometry = new THREE.BufferGeometry()
let pts = []
for(let i=0;i<vertCount;i++){
  x=random(-3,3)
  y=random(-3,3)
  z=random(-3,3)
  pts[i] = (x,y,z)
}
ptsGeometry.setAttribute('position', new THREE.Float32BufferAttribute(pts,3))
const ptsmaterial = new THREE.PointsMaterial({color : cDec,size : 0.05, sizeAttenuation: true, alphaTest: 0.5, transparent: true})
const prtcls = new THREE.Points(ptsGeometry,ptsmaterial)
scene.add(prtcls)

//POST PROCESSING
const composer = new EffectComposer(renderer)
composer.setSize( width,height );
composer.addPass(new RenderPass(scene,camera))

const bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 );
				bloomPass.threshold = 0;
				bloomPass.strength = 0.23;
				bloomPass.radius = 0;

                composer.addPass(bloomPass)
      
                const afterimagePass = new AfterimagePass();
                composer.addPass(afterimagePass)
//ANIMATION
function animate(){
    requestAnimationFrame( animate )
    
    for(let i=0;i<1;i++){
        
       
        p.push(new Particles())
    }
    for(let i=0; i< p.length; i++){
    p[i].display()
    p[i].fall()
    p[0].die()
    }

    //DELETE PARTICLES
    if(p.length>maxP){
    del()
    }
    let rtX = mapRange(noise(inc/1000),0,1,-0.5,0.5); //
    let rtY = mapRange(noise(inc/1000),0,1,-0.5,0.5);    //
    let rtZ = mapRange(noise(inc/1000),0,1,-0.5,0.5);
    prtcls.rotation.y+=rtY/500 //
    prtcls.rotation.x+=rtX/500
    prtcls.rotation.z+=rtZ/500

    controls.update()
   
    //renderer.render(scene,camera)
    composer.render()
}animate()

//RANDOM NUMBERS
function random(min,max){
    return fxrand() * (max-min) + min;
}

//DELETE PARTICLES FUNCTION
function del(){
    
        p.splice(0,1)
    fxpreview()
}

//MAP RANGE
function mapRange (number, inMin, inMax, outMin, outMax) {
    return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}



//////////////////////////////////
function colorPallete(){ 
    //Insert palletes{
      let cor=['#574D68', '#22AED1', '#FFD972', '#FF5C7A', '#3777FF'];
    let cor1=['#071E22', '#1C736F', '#5D837B', '#EA8634', '#EE2E31'];
    let cor2=['#283D3B','#197278', '#EDDDD4', '#C44536', '#772E25'];
    let cor3=['#071E22','#710627','#4E6B7E','#E99F0C','#FB3640'];
    let cor4=['#264653','#2A9D8F','#E9C46A','#F4A261','#E76F51'];
    let cor5=['#050505','#F5E663','#849A8A','#FF841F','#A24A3F']
    let cor6=['#FFCDB2','#FFB4A2','#E5989B','#B5838D','#6D6875']
    let cor7 = ['#F5CCE8', '#33032F','#531253','#EC9DED','#60A4A9']
    let cor8 = ['#E25450','#0E402D','#295135','#A2AE98','#C4E17A']
    let cor9 = ['#73305D', '#369696','#FF621F','#E6E6E6','#381D2A']
    let cor10 = ['#61FAAD','#61707D','#E63946','#F5FBEF','#EECD59']
    let cor11 = ['#F5EDE0','#F18F01','#00AFF5','#6D2231','#D55672']
    let cor12 = ['#F5EDE0','#F18F01','#DE6C83','#6194A8','#4D6C93']
    let cor13 = ['#9A9FAC','#ED9B40','#FFEEDB','#61C9A8','#77567A']
    let cor14 = ['#546EB6','#D7FCD4','#B6CCA1','#CD5334','#FAD8D6']
    //...}
    let cIndex=Math.floor(random(0,cor.length)) //Pick a color
    
    
    //Returns cDec{
    if(pIndex==0){
       cDec=cor[cIndex]
    }
    if(pIndex==1){
       cDec=cor1[cIndex]
    }
    if(pIndex==2){
       cDec=cor2[cIndex]
    }
    if(pIndex==3){
       cDec=cor3[cIndex]
    }
    if(pIndex==4){
       cDec=cor4[cIndex]
    }
    if(pIndex==5){
       cDec=cor5[cIndex]
    }
    if(pIndex==6){
       cDec=cor6[cIndex]
    }
    if(pIndex==7){
        cDec=cor7[cIndex]
     }
     if(pIndex==8){
        cDec=cor8[cIndex]
     }
     if(pIndex==9){
        cDec=cor9[cIndex]
     }
     if(pIndex==10){
        cDec=cor10[cIndex]
     }
     if(pIndex==11){
        cDec=cor11[cIndex]
     }
     if(pIndex==12){
        cDec=cor12[cIndex]
     }
     if(pIndex==13){
        cDec=cor13[cIndex]
     }
     if(pIndex==14){
        cDec=cor14[cIndex]
     }
    //...}
    }

    function features(){

        window.$fxhashFeatures = {
            "Pallete" : getPalleteString(),
            "Particle Shape" : getShapeString(shapeDec),
            "Speed" : getSpeedString(nsSpeed)
          }
    }

    function getPalleteString(){
        return pIndex;
    }
    function getShapeString(value){
        if(value==0&&nsSpeed<0.003) return "Rectangle"
            else return "Point"
    }
    function getSpeedString(value){
        if (value<0.0025) return "Slow"
        if(value>0.0025 && value<0.0035) return "Medium"
        else return "Fast"
    }
//break